//problem z czystym jsem (slideToggle musiałby zostać zamieniony na kombinacje w cssie)

if ($('.accordion-section').length > 0) {
  $('.accordion-single').on('click', function () {
    $('svg', this).toggleClass('rotate');
    $('.accordion-visible-wrapper, .accordion-visible', this).toggleClass('active');
    $('.accordion-hidden', this).slideToggle('fast');
  });

  $('.accordion-hidden a').on('click', function (e) {
    e.stopPropagation();
  });
}
